import * as React from "react";
import styled from "styled-components";
import { Wrapper } from "../styled";
import { Layout, SocialPanel } from "../components";

const MainPageWrapper = styled.div`
  display: flex;
  height: 100%;
`;

const ContentWrapper = styled(Wrapper)`
  display: flex;
  align-items: center;

  @media screen and (max-width: $wrapper-width) {
    flex-direction: column-reverse;
    justify-content: space-around;
  }
`;

const ListWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 30vh;
  min-height: 150px;

  @media screen and (max-width: $wrapper-width) {
    flex-grow: 0;
    width: 60%;
  }

  @media screen and (max-width: 850px) {
    width: 70%;
  }

  @media screen and (max-width: 780px) {
    width: 80%;
  }

  @media screen and (max-width: 600px) {
    width: 90%;
  }
`;

const List = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ListItem = styled.li`
  display: flex;
  align-items: center;
  height: 50px;
  min-height: 40px;
  font-weight: 400;
  font-size: 1.8rem;
  word-spacing: 7px;
  letter-spacing: 1.5px;
  color: hsl(132, 6%, 15%);
  background-color: #fff;
  transition: background-color 0.5s;

  @media screen and (max-width: 700px) {
    flex-direction: column;
    justify-content: space-around;
    height: 80px;
  }
`;

const NameItemContainer = styled(ListItem)`
  position: relative;
  overflow: hidden;
`;

const NameContainer = styled.h1`
  font-size: 2rem;
  font-family: inherit;
`;

const EmailLink = styled.a`
  line-height: 1.6;
  color: hsl(349, 100%, 33%);
  border-bottom: 1px solid hsla(132, 6%, 15%, 0);

  &:hover {
    transform: scale(1.1);
    border-bottom: 1px solid hsla(132, 6%, 15%, 0.5);
    transition: 0.1s;

    @media screen and (max-width: 550px) {
      transform: scale(1.02);
    }
  }

  &:active {
    text-shadow: hsl(349, 100%, 33%) 0px 0px 1px;
  }
`;

const SocialPanelWrapper = styled(ListItem)`
  margin-top: 30px;
`;

export const Home = () => {
  return (
    <Layout>
      <MainPageWrapper>
        <ContentWrapper>
          <ListWrapper>
            <List>
              <NameItemContainer>
                <NameContainer>Alexander Piskun</NameContainer>
              </NameItemContainer>
              <ListItem>
                <EmailLink
                  href="mailto:sannnao.developer@gmail.com"
                  title="Contact me!"
                >
                  sannnao.developer@gmail.com
                </EmailLink>
              </ListItem>
              <SocialPanelWrapper>
                <SocialPanel />
              </SocialPanelWrapper>
            </List>
          </ListWrapper>
        </ContentWrapper>
      </MainPageWrapper>
    </Layout>
  );
};
